import { useContext, useEffect } from 'react';
import { TrackingContext } from './Tracking.context';
import { AppContext } from '../App.context';
import { TrackerLogger } from './Tracking.events';
import { MetaPixelTracker } from './trackers/MetaPixelTracker';

const IS_INSTALLED_KEY = 'pwa-installed';

declare global {
	interface Window {
		dataLayer: any;
		gtag: any;
	}
}

export function useTrackingPageView({
	title,
	location,
}: TrackingPageViewProps) {
	const {
		gtag,
		gtm,
		history,
		setHistory,
		locationChannel,
		matomo,
		plausible,
		metaPixel,
	} = useContext(TrackingContext);
	useEffect(() => {
		if (!title) {
			return;
		}

		if (!location) {
			return;
		}

		let lastPath = undefined;
		if (history.length) {
			lastPath = history[history.length - 1];
			if (lastPath === location) {
				return;
			}
		}

		TrackerLogger.debug(`Page view "${location}"`, {
			title,
			location,
			history,
			lastPath,
		});

		locationChannel.postMessage(location);

		history.push(location);
		setHistory(history);

		if (gtag && window.gtag) {
			// ga.pageview(location, undefined, title);
			window.gtag('event', 'page_view', {
				page_title: title,
				page_location: location,
			});
		}
		if (gtm && window.dataLayer) {
			const gtmEvent = {
				event: 'pageview',
				page: {
					url: location,
					title: title,
				},
			};

			window.dataLayer.push(gtmEvent);
		}
		if (matomo) {
			console.log({
				documentTitle: title,
				href: location,
				//customDimensions: [{ id: 1, value: 'paid' }],
			});
			matomo.trackPageView({
				documentTitle: title,
				href: location,
				//customDimensions: [{ id: 1, value: 'paid' }],
			});
			/*window._paq.push([
				'setCustomUrl',
				location ?? window.location.href,
			]);
			window._paq.push([
				'trackPageView',
				{ documentTitle: title, url: location },
			]);*/
		}
		if (plausible) {
			const url = window.location.href;
			plausible.trackPageview(
				{
					url,
				},
				{
					callback: () =>
						console.log(`Plausible done sending page view: ${url}`),
				},
			);
		}

		if (metaPixel) {
			console.log(`I sent the MetaPixel page view event`);
			MetaPixelTracker.pageView();
		}
	}, [location, title]);
}

export function useTrackingInstallion() {
	const { sendEvent } = useContext(TrackingContext);
	const { isInstalled } = useContext(AppContext);
	useEffect(() => {
		if (localStorage.getItem(IS_INSTALLED_KEY)) {
			return;
		}

		if (!isInstalled) {
			return;
		}

		localStorage.setItem(IS_INSTALLED_KEY, 'true');
		sendEvent({
			type: 'INSTALLED',
		});
	}, [isInstalled]);
}

interface TrackingPageViewProps {
	location?: any;
	title?: string;
}
